export default __webpack_public_path__ + "img/cart3.e7684897.svg";